import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRight, Phone, ShieldCheck } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { PHONE, PHONE_TEL, track, usePageMeta } from "../lib/api";

const STEPS = [
  "We'll review your request.",
  "We'll contact you using the method you selected.",
  "We'll listen first.",
  "If we can help, we'll explain your options.",
];

const ThankYou = () => {
  usePageMeta("We Got It | Show Me Shield", "A real person from Show Me Shield will review your message and follow up using the contact method you selected.", { path: "/thank-you", noindex: true });

  useEffect(() => {
    track("thank_you_view");
  }, []);

  return (
    <main className="bg-ink grid-lines min-h-[70vh]">
      <div className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 sm:py-32" data-testid="thank-you-page">
        <Reveal>
          <ShieldCheck className="mx-auto h-12 w-12 text-lime" strokeWidth={1.5} />
          <h1 className="h-display mt-6 text-4xl text-white sm:text-5xl lg:text-6xl">We got it.</h1>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-zinc-400 sm:text-lg">
            A real person from Show Me Shield will review your message and follow up using the contact
            method you selected.
          </p>

          <div className="mx-auto mt-10 max-w-md rounded-md border border-line bg-ink-3 p-6 text-left">
            <h2 className="font-display text-sm font-bold uppercase tracking-wider text-white">
              What happens next
            </h2>
            <ol className="mt-4 space-y-3">
              {STEPS.map((s, i) => (
                <li key={s} className="flex items-center gap-3 text-sm text-zinc-300">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-lime/50 font-mono text-xs font-bold text-lime">
                    {i + 1}
                  </span>
                  {s}
                </li>
              ))}
            </ol>
          </div>

          <p className="mt-10 text-sm text-zinc-500">Need an answer sooner? Call us.</p>
          <a
            href={PHONE_TEL}
            data-testid="thank-you-phone-cta"
            onClick={() => track("phone_click", { location: "thank_you" })}
            className="mt-3 inline-flex items-center gap-3 font-mono text-2xl font-bold text-lime"
          >
            <Phone className="h-6 w-6" /> {PHONE}
          </a>

          <div className="mt-10">
            <Link to="/" data-testid="thank-you-home-link" className="btn-ghost">
              Back to Home <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </div>
    </main>
  );
};

export default ThankYou;
